import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DiscountMaster = () => {
  // fetch list 
   const [DiscountUser, setDiscountUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/discount_list"
      );
      setDiscountUser(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_discount",
        { disc_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setDiscountUser((prevUser) =>
          prevUser.filter((user) => user.disc_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/discount-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Discount.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Discount Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Master</a>
                </li>
                <li className="breadcrumb-item active">Discount List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4 className="card-title">All Discounts</h4>
                <Link to="/discount-add">
                <button className="btn btn-primary btn-sm">+ Add Discount</button>
                </Link>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Discount Name</th>
                        <th>Percentage</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {DiscountUser.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.disc_name}</td>
                          <td>{item.disc_amount}%</td>
                          <td>{item.disc_start_date}</td>
                          <td>{item.disc_end_date}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                           <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/discount-edit/${item.disc_id}`}
                                href="#!"
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </Link>
                              <span onClick={(e) => deleteUser(item.disc_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {DiscountUser.length === 0 && (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Discounts Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer text-end">
                <small className="text-muted">Total Discounts: {DiscountUser.length}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountMaster;
